<template>
 <div id="admin">
   <menu-admin/>
    <section class="int-form" style="margin-top: 30px;">
      <div class="container">

        <div class="text-right d-print-none"  v-show="signatures.length">
          <a class="badge badge-info" href="#" @click="loadEtiquettes('simple')" style="color: white !important;">
            <i class="fa fa-list" aria-hidden="true"></i> Etiquetas Simples
          </a>
          <a class="badge badge-info" href="#" @click="loadEtiquettes('complete')" style="color: white !important;">
            <i class="fa fa-list" aria-hidden="true"></i> Etiquetas Completas
          </a>
          <a class="badge badge-info" href="#" @click="loadUsers()" style="color: white !important;">
            <i class="fa fa-print" aria-hidden="true"></i> Imprimir
          </a>
        </div>

        <h5>Relatório de Publicação x Clientes</h5>
        <h1>{{ publication.name }}</h1>

        <div class="row" style="margin-top: 30px;">

          <table class="table table-bordered table-sm table-hover" style="background: white;">
          <tr v-show="!signatures.length">
            <td class="text-center" colspan="4">Nenhum usuário pode ser encontrado</td>
          </tr>
        <thead v-show="signatures.length">
          <tr>
            <th class="text-center" width="50" scope="col"><input id="checkAll" type="checkbox" v-model="selectAll" @click="selectItem" /></th>
            <th scope="col">Usuário / Empresa</th>
            <th class="text-center" width="150" scope="col">Vencimento</th>
            <th class="text-center" width="200" scope="col">Prefixo / N Série</th>
          </tr>
        </thead>
        <tbody v-show="signatures.length">
          <tr v-for="signature in signatures" :key="signature">
            <th class="text-center" scope="row"><input checked="checked" type="checkbox" :value="signature.profile.id" v-model="selected" /></th>
            <td v-if="signature.profile.person_or_company">{{signature.profile.company_name}}</td>
            <td v-else>{{signature.profile.name}}</td>
            <td class="text-center">{{signature.due | formatDate}}</td>
            <td class="text-center">
              <span v-if="signature.airplane_serial_number">
              {{signature.airplane_prefix}} / {{signature.airplane_serial_number}}
              </span>
              <span v-if="!signature.airplane_serial_number">
                -
              </span>
            </td>
          </tr>
        </tbody>
      </table>

        </div>
      </div>
    </section>
   <footer-admin/>
  </div>
</template>

<script>
  import user from "../../api/user"
  import publication from "../../api/publication"
  import signature from "../../api/signature"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  import {VMoney} from 'v-money'

  export default {
    name: "ReportPublicationClients",
    mixins: [mixins],
    data () {
      return {
        publication: { name: null },
        signatures: {},
        date: null,
        selected: [],
        selectAll: false
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      export_users(){
        let users_list = ''

        this.selected.forEach(function (item){
          users_list = users_list + item + ','
        })

        if(users_list !== ''){
          users_list = users_list.slice(0, users_list.length-1)
        }
        return users_list
      },
      ...mapState(['logged'])
    },
    directives: { money: VMoney },
    methods: {
      getpublication(id){
          publication.get(id).then((response)  =>  {
            this.publication = response.data
            this.date = this.formatDate(this.publication.date, 'pt-br')

            signature.getClientsByPublication(response.data.id).then((response)  =>  {
              this.signatures = response.data.results
              $("#checkAll").click();
            })
          })
      },
      selectItem(){
        this.selected = [];
          if (!this.selectAll) {
            for (let i in this.signatures) {
              this.selected.push(this.signatures[i].profile.id);
            }
          }
        },
      loadEtiquettes(type){
        let data_users = {
          users: this.export_users,
          type: type
        }
        user.get_addresses(data_users).then((response)  =>  {
            let blob = new Blob([response.data], { type:   'application/pdf' } )
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.string_to_slug(this.publication.name) + '_etiqueta_' + type + '.pdf'
            link.click()
        })
      },
      loadUsers(){
        let data_users = {
          users: this.export_users,
          publication: this.publication.id
        }
        signature.getClientsByPublicationPDF(data_users).then((response)  =>  {
            let blob = new Blob([response.data], { type:   'application/pdf' } )
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.string_to_slug(this.publication.name) + 'usuarios_x_publicacao_' + this.publication.id + '.pdf'
            link.click()
        })
      }
    },
    mounted(){
      if(this.$route.params.id !== undefined && this.$route.params.id > 0) {
        this.getpublication(this.$route.params.id)
      }
    }
  }

</script>
